var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paper',{attrs:{"title":_vm.tab.name,"body-class":"mt-0"}},[_c('div',{staticClass:"px-2 pb-1"},[_c('b-row',[_c('b-col',[_c('p',[_vm._v(" input 1 will be selected when job template is created. ")])])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }